<template>
	<section class="main-content">
		<div class="row">
			<slot>
				<div class="columns column12 align-center">
					<div class="reverse-title-wrapper">
						<h1>{{ title }}</h1>
						<h2 class="subtitle">{{ subtitle }}</h2>
					</div>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.align-center {
	ul,
	:deep(ul),
	ol,
	:deep(ol) {
		list-style-position: inside;
		margin: 0 auto 20px;
		max-width: 780px;
		text-align: left;
	}
}

@media (max-width: 880px) {
	.intro {
		padding: 50px 0;
	}
}
</style>
